export default __webpack_public_path__ + "46eb0cc48f433761f95ce257c33c8042.svg";